'use strict';

import ReportsList from './reports.list.ctrl';
import ReportsView from './view/viewReport';
import ReportsSystemStatus from './reports.status.ctrl';
import ReportsSystemStatusTime from './reports.status.time/reports.status.time.directive';

export default angular
  .module('main.reports', [
    ReportsList,
    ReportsView,
    ReportsSystemStatus,
    ReportsSystemStatusTime,
  ])
  .name;
